<template>
  <v-container fluid>
    <v-row class="flex-column">
      <v-col cols="12" class="mt-4">
        <v-row justify="center">
          <v-col
            cols="12"
            class="text-center mb-4 font-size--18 font-weight-bold"
            v-if="isNyOrThirdParty"
          >
            <h2>{{ $t('L_request_reinstatement_application') }}</h2>
          </v-col>
          <v-col cols="12" class="text-center mb-4 d-flex justify-center align-center flex-column">
            <v-img
              class="mb-4"
              width="240"
              alt="overview reinstatement icon"
              src="../assets/NextStepImageOriginalDate.svg"
            />
            <v-row>
              <v-col xs0 sm="1" md="2" lg="2"> &nbsp; </v-col>
              <v-col cols="12" sm="10" md="8" lg="8" class="font-size-16 text-left">
                <div class="font-size--16 font-weight-bold">
                  {{ $t('L_your_request_for_a_paper_reinstatement_application_has_been_received') }}
                </div>
                <div class="font-size--16 mt-4">
                  {{
                    $t(
                      'L_please_allow_up_to_a_week_to_receive_the_paper_application_you_must_complete_and_mail_the'
                    )
                  }}
                </div>
                <div class="font-size--16 mt-4">
                  {{
                    $t(
                      'L_submission_of_the_applicatioN_deon_not_guarantee_coverage_coverage_will_not_go'
                    )
                  }}
                </div>
                <div class="font-size--16 mt-4">
                  <span>{{
                    $t(
                      'L_if_you_have_questions_please_contact_your_representative_or_client_service',
                      [customerServicePhoneNum]
                    )
                  }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- Button -->
        <v-row class="d-flex align-center justify-center py-4">
          <v-col cols="12" sm="6" md="4" class="pr-4">
            <OnexButton :disabled="disableActions" block color="primary" @click="continueAction">
              {{ $t('L_done') }}
            </OnexButton>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global/global.store';
import { defineComponent, type ComponentOptions } from 'vue';
import { OnexButton } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'ReinstatementOriginalIssueNextSteps',
  components: {
    OnexButton,
  },
  props: {
    disableActions: {
      type: Boolean,
      default: false,
    },
    isNyOrThirdParty: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapState(useGlobalStore, {
      locale: 'locale',
    }),
    customerServicePhoneNum() {
      if (this.locale === 'en_US') {
        return '(800) 257-4725';
      } else if (this.locale === 'en_CA') {
        return '(800) 387-7876';
      } else if (this.locale === 'fr_CA') {
        return '(800) 265-4804';
      }
      return '(800) 257-4725';
    },
  },
  methods: {
    continueAction() {
      this.$emit('continueClicked');
    },
    // cancelAction() {
    //   this.$emit('cancelClicked');
    // },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.bluetext {
  color: #063562;
}
</style>
